import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Sparkle } from '@phosphor-icons/react';
import Button from '../../components/Button';
import { captureAnalytics } from '../../actions/preload';
import { useSetupAssistantAllowed } from './useSetupAssistantAccess';
import './setupEntryButton.scss';

export const SETUP_PATH = '/app/referred/setup';

export const mapEntryState = (state) => ({
  isAdmin: state.auth?.data ? Boolean(state.auth.isAdmin) : null,
});

export const SetupEntryButtonBase = ({
  source, isAdmin, navigate, wrapperClassName,
}) => {
  const allowed = useSetupAssistantAllowed(isAdmin);
  if (!allowed) return null;

  const button = (
    <Button
      type="primary"
      size="xsmall"
      label="Set up Referral Management"
      leftIcon={<Sparkle size={16} weight="fill" />}
      onClick={() => {
        captureAnalytics('referral_setup_assistant_opened', { source });
        navigate(SETUP_PATH);
      }}
    />
  );
  return wrapperClassName ? <div className={wrapperClassName}>{button}</div> : button;
};

SetupEntryButtonBase.propTypes = {
  source: PropTypes.oneOf(['action_bar', 'legacy']).isRequired,
  isAdmin: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,
};

SetupEntryButtonBase.defaultProps = {
  isAdmin: false,
  wrapperClassName: null,
};

/**
 * "Set up Referral Management" button that opens the setup page. Renders
 * nothing unless the user is an org admin and the org has
 * `referral_setup_assistant`, `medsender_gpt` and referral management. A click
 * records `referral_setup_assistant_opened` with `source`. `wrapperClassName`
 * wraps the button in a div that renders only when the button does.
 */
const SetupEntryButton = connect(
  mapEntryState,
  { navigate: push },
)(SetupEntryButtonBase);

export default SetupEntryButton;
